var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1550px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline mb-0" },
            [
              _c("v-icon", [_vm._v("close")]),
              _vm._v(" Rechazar permiso\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0 px-4" },
            [
              _c(
                "v-container",
                {
                  staticClass: "p-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "subtitulo" }, [
                          _c("strong", [_vm._v("Número:")]),
                          _vm._v(" " + _vm._s(_vm.permiso.numero))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "subtitulo" }, [
                          _c("strong", [_vm._v("Funcionario:")]),
                          _vm._v(
                            " " + _vm._s(_vm.permiso.nombres) + "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "subtitulo" }, [
                          _c("strong", [_vm._v("Tipo de papeleta:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.permiso.tipo_permiso) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "subtitulo" }, [
                              _c("strong", [_vm._v("Lugar de comisión :")]),
                              _vm._v(" " + _vm._s(_vm.permiso.lugar))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 5
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "subtitulo" }, [
                              _c("b", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.permiso.id_parametro_permiso
                                        ? _vm.tipo_capacitacion
                                        : ""
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87 ||
                      _vm.permiso.id_tipo_permiso == 96 ||
                      _vm.permiso.id_tipo_permiso == 101
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Motivo:")]),
                              _vm._v(" " + _vm._s(_vm.permiso.permiso.motivo))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 90
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Tipo de baja:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.permiso.permiso.motivo) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 44
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [
                                _vm._v("Condición o estado crítico de salud :")
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.permiso.permiso.motivo) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("span", { staticClass: "titulo-rechazar" }, [
                          _vm._v("Detalles de papeleta.")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 8
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_caja
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_desde,
                                                        "HH:mm"
                                                      )
                                                      .add("00:20")
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.hora_hasta,
                                                        "HH:mm"
                                                      )
                                                      .add("00:20")
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.total_horas,
                                                        "HH:mm"
                                                      )
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.permiso.id_tipo_permiso == 24
                                            ? _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.item.total_dias
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3833679281
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _vm.permiso.id_tipo_permiso == 87 ||
                      _vm.permiso.id_tipo_permiso == 96 ||
                      _vm.permiso.id_tipo_permiso == 88 ||
                      _vm.permiso.id_tipo_permiso == 102 ||
                      (_vm.permiso.id_tipo_permiso >= 37 &&
                        _vm.permiso.id_tipo_permiso <= 43)
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-data-table",
                                {
                                  staticClass:
                                    "tabla-comprimida-light elevation-1",
                                  attrs: {
                                    items: _vm.permiso_detalles2,
                                    "hide-actions": "",
                                    headers: _vm.headers_horas
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.fecha_salida
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      props.item.fecha_hasta
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.hora_desde)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-center" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.hora_hasta)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.permiso.id_tipo_permiso != 102
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm
                                                            .$moment(
                                                              props.item
                                                                .total_horas,
                                                              "HH:mm"
                                                            )
                                                            .format("HH:mm")
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.permiso.id_tipo_permiso == 102
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm
                                                            .$moment(
                                                              props.item
                                                                .total_horas,
                                                              "HH:mm"
                                                            )
                                                            .format("HH:mm")
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1008528804
                                  )
                                },
                                [_vm._v("\n              >\n              ")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 14 ||
                  _vm.permiso.id_tipo_permiso == 105 ||
                  (_vm.permiso.id_tipo_permiso >= 98 &&
                    _vm.permiso.id_tipo_permiso <= 101) ||
                  _vm.permiso.id_tipo_permiso == 89 ||
                  _vm.permiso.id_tipo_permiso == 18
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias_decimales
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.total_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2564384688
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  [6, 44, 95, 61, 12, 90, 5].includes(
                    parseInt(_vm.permiso.id_tipo_permiso)
                  )
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_dias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.total_dias)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2250887660
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 94
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles2,
                                  "hide-actions": "",
                                  headers: _vm.headers_registro_asistencias
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_salida
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.fecha_hasta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4232213432
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c("v-layout", [
                        _c("span", { staticClass: "titulo-rechazar" }, [
                          _vm._v(" Detalles compensacion")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "tabla-comprimida-light elevation-1",
                                attrs: {
                                  items: _vm.permiso_compensacion,
                                  "hide-actions": "",
                                  headers: _vm.headers2
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_desde
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        props.item.fecha_hasta
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_desde)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                _vm._s(props.item.hora_hasta)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-center" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.item.diferencia_horas
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  486249175
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 88 ||
                  (_vm.permiso.id_tipo_permiso == 96 &&
                    _vm.permiso.compensa_tolerancia == 1)
                    ? _c(
                        "v-layout",
                        { staticClass: "pa-2" },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [
                                _vm._v(
                                  "Total horas: " +
                                    _vm._s(_vm.total_horas_acomuladas)
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-layout", { staticClass: "text-xs-center" }, [
                    _c("span", { staticClass: "titulo-rechazar" }, [
                      _vm._v(" Seguimiento de papeleta")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "tabla-comprimida-light elevation-1",
                            attrs: {
                              items: _vm.detalle_seguimiento,
                              "hide-actions": "",
                              headers: _vm.headers_detalle
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.fecha_registro) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.estado))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.usuario))]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md12: "" } },
                        [
                          _c("v-textarea", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              rows: "2",
                              label: "Justificación del rechazo",
                              "auto-grow": "",
                              rules: _vm.$validate(["required"]),
                              required: "",
                              outline: "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.form.justificacion_rechazo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "justificacion_rechazo", $$v)
                              },
                              expression: "form.justificacion_rechazo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "px-4" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secundary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("check")]),
                  _vm._v("\n        Cancelar\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.apruebaRechazaPermiso(_vm.permiso)
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("clear")]),
                  _vm._v("\n        Rechazar\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0225b56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0225b56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/RechazarPermisoRRHH.vue
// module id = null
// module chunks = 